import React from "react";

import { localizer } from "../../../Translator";

import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from  "@material-ui/core";
import { Typography } from "@material-ui/core";

import { TextFieldStyled } from "../../common/InputStyled";


/* Setting initial empty email address state */
const initialState = {
  email: "",

  emailInvalidMessage: ""
  /* certificateEmail: false,
  emissionEmail: false */
}

export class EmailAddressModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  /* Handle onChange event for all text & checkbox inputs */
  onInputchange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onCheckboxChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked })
  }

  /* Validating text introduced by user and sending to parent component to be stored */
  doStoreEmail = () => {
    if (!this.state.email) return

    var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

    // Using test we can check if the text match the pattern
    if (validEmail.test(this.state.email)) {
      this.setState({ emailInvalidMessage: "" })
      this.props.handleEmail(this.state.email, "POST")
      this.doCloseModal()
    } else {
      this.setState({ emailInvalidMessage: localizer.EmailAddressInvalidEmail })
    }
   
  }

  /* Handle modal open/close events */
  doCloseModal = () => {
    this.setState(initialState, () => { this.props.handleCloseModal() })
  }

  render() {
    return (
      <React.Fragment>

        <Dialog
          open={this.props.openModal}
          onClose={this.doCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseModal}></i>
            <Typography className="typography-generic dialog-title" >{localizer.EmailAddressAddEmail}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">

            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={2}>
                <TextFieldStyled id="ea-email" className="typography-generic" name="email"
                  label={<Typography className="typography-generic">{localizer.EmailAddressEmail}</Typography>}
                  value={this.state.email} onChange={this.onInputchange} variant="outlined" fullWidth InputProps={{
                    classes: {
                      input: "typography-generic"
                    }
                  }} />
                <span className="typography-generic color-red">{this.state.emailInvalidMessage}</span>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.doCloseModal}>{localizer.Cancel}</Button>
                <Button className="button-generic dialog-primary" variant="contained" onClick={this.doStoreEmail}>{localizer.Add}</Button>
              </Grid>
            </Grid>
            
          </DialogContent>
        </Dialog>

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/email-address/sections/EmailAddressModal.js